var $c13d7ab62c1cb271$exports = {};
$c13d7ab62c1cb271$exports = import.meta.resolve("6tniw");


var $5a24c2e6bbd561e9$exports = {};
$5a24c2e6bbd561e9$exports = import.meta.resolve("1zBDP");


var $34522acfb93ff0e9$exports = {};
$34522acfb93ff0e9$exports = import.meta.resolve("3HZVk");


var $4c69eb6f0509df20$exports = {};
$4c69eb6f0509df20$exports = import.meta.resolve("ilINb");


window.addEventListener("load", function() {
    var date = new Date();
    var hour = date.getHours();
    var day = 5 < hour && hour < 19;
    document.getElementById("img1").src = day ? new URL($c13d7ab62c1cb271$exports) : new URL($5a24c2e6bbd561e9$exports);
    document.getElementById("img2").src = day ? new URL($34522acfb93ff0e9$exports) : new URL($4c69eb6f0509df20$exports);
});


//# sourceMappingURL=repo.e3ed7c0a.js.map
